import { FC } from 'react'
import Sun from '@/assets/img/icons/sun.png'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 30, height = 30 }) => {
  return (
    <img
      src={Sun}
      alt='IconLightTower'
      width={width}
      height={height}
    />
  )
}

export default Icon
